import styled from "@emotion/styled";
import { tooltipClasses, Tooltip as MuiTooltip } from "@mui/material";
import React from "react";

const CustomTooltip = ({ length = 20, children }) => {
  const CustomTooltipTheme = styled(({ className, ...props }) => (
    <MuiTooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#4971b2",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#4971b2",
    },
  }));

  return (
    <CustomTooltipTheme title={children} arrow className="custom-tooltip">
      <span>
        {children?.length > length
          ? children?.slice(0, length) + "..."
          : children}
      </span>
    </CustomTooltipTheme>
  );
};

export default CustomTooltip;
